
export class ErrorDataFetch extends Error {
    constructor(message: string, public readonly code: number) {
        super(message);
    }
}
